module.exports = __webpack_public_path__ + "img/31423169000420.61df87cf.png";